import React from 'react';
import { Helmet } from 'react-helmet';

function Home_Seo() {
    return (
        <div>
            <Helmet>
                <title>Money Transfer to Nigeria | FinestPay</title>
                <meta name="description" content="Welcome to FinestPay trading as Remit to Africa. We are one of the leading Money Remitters to Nigeria. Low Fees and Quick Service is our promise." />
                <meta property="og:title" content="Money Transfer to Nigeria | FinestPay" />
                <meta property="og:description" content="Welcome to FinestPay trading as Remit to Africa. We are one of the leading Money Remitters to Nigeria. Low Fees and Quick Service is our promise." />
                <meta property="og:image" content="https://finestpay.co.uk/assets/img/FinestPay-icon.png" /> {/* Replace with actual image URL */}
                <meta property="og:url" content={window.location.href} />
                <meta property="og:type" content="website" />
                <link rel="canonical" href="https://finestpay.co.uk/" />
            </Helmet>
        </div>
    )
}

export default Home_Seo
